import React, { useState, useRef, useEffect } from "react";
import useIntersection from "react-use/lib/useIntersection";
import random from "lodash/random";

const MAX_ANIMATION_DELAY = 6000;

// lottie-web accesses `document` at import time. Node 22+ exposes a global
// `navigator`, so lottie's server-side guard no longer skips evaluation.
// Dynamic import after mount keeps lottie-web client-only.
function useLottie() {
  const [Component, setComponent] = useState<React.ComponentType<any> | null>(
    null
  );

  useEffect(() => {
    import("react-lottie-player/dist/LottiePlayerLight").then((mod) =>
      setComponent(() => mod.default)
    );
  }, []);

  return Component;
}

export const ForestTileAnimation = ({
  animation,
  randomStart = false,
}: {
  animation: object;
  randomStart: boolean;
}) => {
  const ref = useRef(null);
  const intersection = useIntersection(ref, {});
  const [play, setPlay] = useState(false);
  const Lottie = useLottie();

  const playAnimation = () => {
    if (randomStart) {
      setTimeout(() => {
        setPlay(true);
      }, random(MAX_ANIMATION_DELAY));
    } else {
      setPlay(true);
    }
  };

  useEffect(() => {
    // Only play animation when in view
    if (intersection?.isIntersecting) {
      playAnimation();
    } else {
      setPlay(false);
    }
  }, [intersection?.isIntersecting]);
  return (
    <div ref={ref}>
      {Lottie && <Lottie animationData={animation} play={play} loop />}
    </div>
  );
};
